// extracted by mini-css-extract-plugin
export default {"form":"SignUpForm_form__CGOfo","submit":"SignUpForm_submit__ffmnV","selector":"SignUpForm_selector__DXv1x","preloader":"SignUpForm_preloader__YdRay"};